module.exports = __webpack_public_path__ + "static/img/8.031dfcf.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/1/eng/8.png
// module id = I9xO
// module chunks = 0